import React, { memo } from "react";
import { useLoader } from "react-three-fiber";
import { TextureLoader } from "three";

import useSlider from "hooks/useSlider";

import Blur from "./Blur";
import Bubble from "./Bubble";

const Scene = ({ images, refractImg }) => {
  const textures = useLoader(TextureLoader, images);
  const refractTexture = useLoader(TextureLoader, refractImg);
  const index = useSlider(images.length);

  return (
    <>
      <Blur index={index} />
      <Bubble map={textures[index]} refractMap={refractTexture} />
    </>
  );
};

export default memo(Scene);
